import { KEY_PREFIX, useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { Redirect, useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { SearchResultsPage } from '../SearchResultsPage';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExploreSearchResultsProxy() {
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const searchParams = useSearchParams();

  // /explore/page/:page → always redirect
  if (parsedPathParams.page) {
    const params = new URLSearchParams(location.search);
    params.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    const search = params.toString();
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: Paths.SEARCH_RESULTS_PRODUCTS,
        search: search ? `?${search}` : ''
      }
    });
  }

  // /explore without a search query → redirect to /explore/products
  if (!searchParams.get('search')) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: `${Paths.SEARCH_RESULTS_PRODUCTS}${location.search}`
    });
  }
  return /*#__PURE__*/_jsx(SearchResultsPage, {});
}